import { TemplatePage } from './types';

const live_streaming_night_city_theme: TemplatePage = {
  header: {
    color: '#83DEF3',
    icon: 'images/video-templates/facebook-cover.jpg',
    title: 'Live Stream Templates — Night City Theme',
    title_meta: 'Free Live Stream Overlay Templates — Night City Theme',
    description_meta:
      'Adorn your live streams with Wave.video’s collection of editable night-city-themed overlay templates.',
    description:
      'Adorn your live streams with our collection of editable night-city-themed templates.'+
      ' Grab and hold the attention of your audience with ease!'
  },
  footer: {
    category: 'Live Stream Night City Theme',
    description:
      'With Wave.video’s diverse collection of themed customizable templates, you can make your live streams' +
      ' stand out from the competition with no effort. Leave a lasting impression on your audience with unique' +
      ' intros, outros, thumbnails, overlays, and lower thirds without hiring professional video editors. It has'+
      ' never been easier to become a top-notch live streamer!'
  },
  content: [
    {
      type: 'templates',
      title: 'Live Stream Templates — Night City Theme',
      search: { name: 'NightCityTheme', tags: 'NightCityTheme' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_night_city_theme;
